<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    en: {
    },
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout
  },
  data() {
    return {
      vouchers: null,
    };
  },
  methods: {
    getVouchers() {
      this.vouchers = null;

      api
        .get("packages/vouchers")
        .then((response) => {
          if (response.data.status == "success") {
            this.vouchers = response.data.list;
          }
        })
        .catch((error) => {
          if (error) {
            this.vouchers = [];
          }
        })
    },
  },
  mounted() {
    this.getVouchers();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/packages">Pacotes</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">Token LI</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Token LI</h3>
        <p></p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!vouchers">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="vouchers && vouchers.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead class="thead-light">
              <tr>
                <th>Data</th>
                <th style="width: 50px;">Código</th>
                <th></th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in vouchers" :key="row.index">
                <td>{{ row.date }}</td>
                <td>
                  <h5 class="mb-0">{{ row.code }}</h5>
                </td>
                <td>
                  <button class="btn btn-link p-0 m-0" v-clipboard:copy="row.code
                    " v-on:click="$toast.success('O código foi copiado!')">
                    <i class="bx bx-copy font-size-20 text-dark"></i>
                  </button>
                </td>
                <td>
                  <span v-if="row.status == 'available'" class="badge badge-info font-size-12 text-uppercase">Disponível</span>
                  <span v-else-if="row.status == 'used'" class="badge badge-success font-size-12 text-uppercase">Usado</span>
                  <span v-else-if="row.status == 'expired'" class="badge badge-danger font-size-12 text-uppercase">Expirado</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </Layout>
</template>